import type { FC } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

import type { ITheme } from '@homeviews/styles'
import { Typography } from '@material-ui/core'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '3px 0 3px 5px',
      height: 32,
      border: `2px solid #000433`,
      borderRadius: 24,
      width: 60,
      flexShrink: 0,
      '& p': {
        fontSize: theme.typography.pxToRem(12),
        letterSpacing: 0,
        lineHeight: theme.typography.pxToRem(13),
        margin: 0,
        textAlign: 'center',
        color: '#4E516B',
        fontWeight: 500,
      },
      '&:hover': {
        cursor: 'pointer',
      },
    },
    active: {
      backgroundColor: '#000433',
      border: `1px solid #000433`,
      '& p': {
        color: '#fff',
        fontWeight: 500,
      },
    },
    text: {},
  }),
)

interface IProps {
  value: string
  label: string
  onClick: (id: string) => void
  active?: boolean
}

const PillFilter: FC<IProps> = ({ value, label, active, onClick }) => {
  const classes = useStyles()
  return (
    <div
      className={clsx(classes.root, active && classes.active)}
      onClick={() => onClick(value)}
    >
      <Typography className={classes.text}>{label}</Typography>
    </div>
  )
}

export default PillFilter
